import { NotFoundNewLandingi } from './NotFoundNewLandingi'

export const routes = {
  path: '*',
  element: <NotFoundNewLandingi />
}
